import { initI18n } from "@garther/ui/libs";

// Import translation files
import en from "./locales/en.json";
import vi from "./locales/vi.json";

// Initialize i18n with app-specific translations
initI18n({
  resources: {
    en,
    vi
  },
  defaultLanguage: "vi",
  fallbackLanguage: "vi",
  debug: import.meta.env.DEV
});
